function warnOnMissingDataAttr($elem, attr) {
  if ( typeof $elem.data(attr) == 'undefined' ) {
    console.error("data-" + attr + " attribute is not defined on " + $elem);
    return
  }
}

$(document).on('click', '.js-show-all-track-courses', function(e) {
  e.preventDefault();
  $('.js-track-block').removeClass('hidden');
  // Hide the bars below the last course which suggested that there are more
  // courses
  $('.tracks__courses-continued-1, .tracks__courses-continued-2').remove();
  $('.course-block--track .course-block--stacked').removeClass('course-block--stacked');
  $('.track__course--last').removeClass('track__course--last');
  $('.track__course:last').addClass('track__course--last');

  $(this).remove();
});

function setTrackVersionCookie(element) {
  warnOnMissingDataAttr(element, 'cookie');
  warnOnMissingDataAttr(element, 'cookie-expires');
  warnOnMissingDataAttr(element, 'track-version-id');

  var cookieName = element.data('cookie');
  var expiresEpoch = element.data('cookie-expires');
  var trackVersionId = element.data('track-version-id');
  var expirationTime = new Date(expiresEpoch);
  Cookies.set(cookieName, '1', { expires: expirationTime });
}

// Outdated track alert can be dismissed by clicking close, which sets a cookie
// so we know not to show it again.
$(document.body).on('click', '.js-dismiss-track-alert', function(e) {
  e.preventDefault();

  setTrackVersionCookie($(this));

  $('.js-track-outdated-' + trackVersionId).hide();
  $('.js-track-outdated-' + trackVersionId).remove();
});

// Outdated track alert can also link to outdated track page, so we need to
// follow the href set
$(document.body).on('click', '.js-dismiss-track-alert-link', function(e) {
  e.preventDefault();
  var $btn = $(this);

  setTrackVersionCookie($btn);
  window.location = $btn.attr('href');
});
